// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { ButtonIcon } from "@insite/mobius/Button";
import { css } from "styled-components";

const buttonStyles = css`
    white-space: nowrap;
    margin-left: 10px;
    margin-top: 2px;
`;

headerStyles.titleGridItem = {
    width: [10, 9, 7, 5, 6],
};

headerStyles.buttonsGridItem = {
    width: [2, 3, 5, 7, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};

headerStyles.costCodesButton = {
    variant: "tertiary",
    css: buttonStyles,
};

headerStyles.assignBudgetsButton = {
    variant: "tertiary",
    css: buttonStyles,
};

headerStyles.configureBudgetsButton = {
    css: buttonStyles,
};

headerStyles.overflowMenu = {
    buttonProps: {
        css: css`
            height: auto;
            margin-left: 5px;
            margin-top: 2px;
            ${ButtonIcon} {
                top: 0;
            }
        `,
    },
    cssOverrides: {
        wrapper: css`
            height: auto;
        `,
    },
};

headerStyles.gridContainer = {
    gap: 0,
    css: css`
        display: flex;
        padding-bottom: 15px;
    `,
};
